import { siteService } from '@/services/SiteService';
import { orderService } from '@/services/OrderService';
import { attachmentService } from '@/services/AttachmentService';
export default {
    name: "myOrderList",

    data: () => {
        return {

            loading: true,
            items:[],
            //create columns
            fields : [
                { key: 'Type', label: 'Tip', sortable: true, thStyle: 'width:10%' },
                { key: 'OwnerName', label: 'Asigurat', sortable: true },
                { key: 'Detail1', label: 'Bun asigurat', sortable: true, thStyle: 'width:20%' },
                { key: 'Insurer', label: 'Valabilitate', sortable: true, thStyle: 'width:20%' },
                //{ key: 'RequestDate', label: 'Data comanda', sortable: true, thStyle: 'width:15%' },
                { key: 'Policy', label: 'Polita', sortable: false, thStyle: 'width:20%' },
                //{ key: 'Id', label: '', thStyle: 'min-width:100px' }
            ]

        }
    },
    computed: {
        orderStatus() {
            return orderService.orderStatus;
        },

        requestStatus() {
            return orderService.requestStatus;
        },
    },
    created() {
        this.$store.dispatch('user/userRequest')
            .catch((err) => {
                this.$router.push({ name: 'Login' });
            });

        // get my orders
        siteService.getMyOrders().then((response) => {
            this.items = response.data;
            this.loading = false;
        })
    },
    methods: {

        getStatusText(item) {
            var badgeText = 'Oferta';

            switch (item.RequestStatus) {
                case 0: // new
                    var badgeText = 'Cerere';
                    break;
                case 1: //in progress
                    var badgeText = 'Preluata de ' + item.Operator;
                    break;
                case 2: // Done

                    switch (item.Status) {
                        case 4: //Policy = 4, // Policy issued
                            var badgeText = 'Polita emisa';
                            break;
                        case 5: //Canceled = 5, // policy canceled
                            var badgeText = 'Anulata';
                            break;
                        case 6: //Blocked = 5, // policy canceled
                            var badgeText = 'Blocata';
                            break;
                        default:
                    }

                    break;

                default:
            }

            return badgeText;
        },
        getStatusVariant(item) {
            var badgeVariant = 'primary';
            switch (item.Status) {
                case 0, 1, 2: // draft/request/Confirmed = 2, // offer accepted
                    badgeVariant = 'danger';
                    if (item.RequestStatus == this.requestStatus.inProgress) {
                        badgeVariant = 'warning';
                    }
                    break;
                case 4: //Policy = 4, // Policy issued
                    badgeVariant = 'success';
                    break;
                case 5: //Canceled = 5, // policy canceled
                    badgeVariant = 'secondary';
                    break;
                case 6: //Blocked = 5, // policy canceled
                    badgeVariant = 'dark';
                    break;
                default:
            }
            return badgeVariant;
        },

        //#region Download
        downloadPolicy: function (item) {
            var uploadParams = {
                targetType: 0,
                targetId: item.Id
            };
            attachmentService.getAllAttachments(uploadParams).then((response) => {
                var attachments = response.data;

                if (attachments && attachments.length > 0) {
                    if (attachments[0].url)
                        window.location.href = attachments[0].url;
                    else
                        window.location.href = 'api/Attachment/Download/' + attachments[0].Id;
                }
                else {
                    this.showNoDocumentMessage('Download polita');
                }
            });
        },

        downloadPaymentReceipt: function (item) {
            var uploadParams = {
                targetType: 1,
                targetId: item.Id
            };
            attachmentService.getAllAttachments(uploadParams).then((response) => {
                var attachments = response.data;

                if (attachments && attachments.length > 0) {
                    if (attachments[0].url)
                        window.location.href = attachments[0].url;
                    else
                        window.location.href = 'api/Attachment/Download/' + attachments[0].Id;
                }
                else {
                    this.showNoDocumentMessage('Download chitanta');
                }
            })
        },

        showNoDocumentMessage: function (title) {
            this.boxTwo = ''
            this.$bvModal.msgBoxOk('Nu a fost gasit nici un document atasat.', {
                title: title,
                okVariant: 'success',
                buttonSize: 'lg',
                headerClass: 'p-2 border-bottom-1',
                footerClass: 'p-2 border-top-0 mx-auto',

                centered: true
            })
                .then(value => {
                    this.boxTwo = value
                })
                .catch(err => {
                    // An error occurred
                })
        },
        //#endregion
    },

    validations: {
    },
};
